<template>
  <v-container>
    <h2>Alta Call TSM traffic</h2>
    <iframe plausible-embed src="https://a.altacalltsm.fr/share/altacalltsm.fr?auth=id_to_change&embed=true&theme=dark" scrolling="no" frameborder="0" loading="lazy" style="width: 1px; min-width: 100%; height: 1600px;"></iframe>
    <div style="font-size: 14px; padding-bottom: 14px;">Stats powered by <a target="_blank" style="color: transparent; text-decoration: underline;" href="https://plausible.io">Plausible Analytics</a></div>
  </v-container>
    
    
</template>

<script>
// @ is an alias to /src

export default {
  created () {
    // this.$router.push('/communities')
  }
}
</script>
